// extracted by mini-css-extract-plugin
export default {"customSwitch":"PolicyCustomStyles_customSwitch__uEclN"};